import React from "react"
import { store } from './store/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import ContactApp from './ContactApp'

const ContactIndex = (props) => (
  <Provider store={store}>
    <BrowserRouter>
      <ContactApp
        layout = {props.layout}
      />
    </BrowserRouter>
  </Provider>
);

export default ContactIndex